import {Location} from "../../../services/location-service";

const LocationContent = ({location}: {location: Location}) => {
    return <>
        <img alt={location.name} src={location.url} style={{width: '100%', height: '100%', objectFit: 'contain'}}/>
    </>
}


export default LocationContent;